export default __webpack_public_path__ + "static/media/emergencyAmbulance.589264bc.svg";